import StaticVar from 'config/StaticVar';
import { useEffect, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import API from 'services/api';

const DynamicHead = () => {
  const [config, setConfig] = useState({
    title: '',
    favicon: '',
  });

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await API.getAppConfig();

        setConfig({
          title: response.data.title,
          favicon: response.data.logoUrl,
        });


      } catch (error) {
        console.error('Error fetching config:', error);
      }
    };

    fetchConfig();
  }, []);


  return (
    <HelmetProvider>
      <Helmet>
        <title>{config.title}</title>

        {/* Favicon dengan cache busting */}
        <link
          rel="icon"
          href={`${StaticVar.URL_API}${config.favicon}`}
        />

        {/* Apple Touch Icon */}
        <link
          rel="apple-touch-icon"
          href={`${StaticVar.URL_API}${config.favicon}`}
        />

      </Helmet>
    </HelmetProvider>
  );
};

export default DynamicHead;
